import { AfterViewInit, Component, ElementRef, isDevMode, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { StatusBarService } from 'src/services/status-bar-service';

@Component({
    selector: 'status-bar',
    templateUrl: './status-bar.html',
    styleUrls: ['./status-bar.scss'],
    standalone: false
})
export class StatusBar implements OnInit, AfterViewInit {

  @ViewChild('statusLabelLeft') private statusLabelLeft!: ElementRef<HTMLLabelElement>;
  @ViewChild('statusLabelRight') private statusLabelRight!: ElementRef<HTMLLabelElement>;
  private environment?: string;

  constructor(private statusBarService: StatusBarService) {

    statusBarService.onStatus.subscribe((s) => {
      this.statusLabelLeft.nativeElement.innerText = s;
    });

    statusBarService.onAppend.subscribe((s) => {
      this.statusLabelLeft.nativeElement.innerText += ". " + s;
    });

    statusBarService.onClear.subscribe((s) => {
      this.statusLabelLeft.nativeElement.innerText = "";
    });
  }
  ngAfterViewInit(): void {
    this.statusLabelRight.nativeElement.innerText = "v" + environment.version + " (" + this.environment + ")";
  }

  ngOnInit() {
    if(isDevMode()) {
      this.environment = "Dev/QA"
    }
    else {
      this.environment = "Prod"
    }
  }
}
